export default "__VITE_ASSET__DciX17oi__"